<template>
<ul class="flex flex-col pt-2 w-full md:w-1/2 pr-4 border-r border-r-slate-600/50">
    <li class="w-full mb-3">
        <label for="sort" class="text-sm text-slate-400 ml-1">Sort:</label>
        <ul class="sort flex flex-wrap justify-center items-center">
            <li v-for="sortOption in ['newest', 'oldest', 'name']" :key="sortOption" :class="[order == sortOption ? 'bg-green-100 text-black' : 'bg-green-500 text-white', 'flex-1 text-center py-1 cursor-pointer mx-1 px-1']">
                <button @click="order=sortOption">{{ sortOption }}</button>
            </li>
        </ul>
    </li>
    <li class="w-full mb-3">
        <label for="searchbox" class="text-sm text-green-200">Search by culture, name or ingredient:</label>
        <input id="searchbox" class="!bg-green-800 placeholder:text-white p-1 w-full" type="text" v-model="term" placeholder="Enter some stuff">
    </li>
    <li class="w-full">
        <ul class="flex flex-wrap justify-start">
            <li v-for="r in recipesFiltered" class="recipe relative w-1/4 mb-1" :key="r.id">
                <Link :href="`/recipes/${r.slug}`" :only="['recipe']" :except="['recipes']" class="flex flex-col group justify-end p-1 pt-2">
                    <vue-feather v-show="r.id == recipe?.id" type="star" size="24px" class="star absolute top-1 left-1" />
                    <div class="relative overflow-hidden">
                        <img
                            :class="[r.id == recipe?.id ? 'scale-105' : 'grayscale-50', 'pic group-hover:scale-105 group-hover:grayscale object-cover h-24 w-full']"
                            :src="printBG(r)"
                            :alt="r.name"
                        >
                        <div class="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex items-end p-1">
                            <h2 :class="[r.id == recipe?.id ? 'text-yellow-200' : 'text-gray-200', 'group-hover:text-yellow-200 text-xs leading-tight text-center w-full']">
                                {{ r.name }}
                            </h2>
                        </div>
                    </div>
                </Link>
            </li>
        </ul>
    </li>
</ul>
</template>

<script>
import { Link } from '@inertiajs/vue3';
export default {
    name: "RecipeList",
    components: { Link },
    props: ['recipes', 'recipe'],
    computed: {
        recipesFiltered() {
            let repfilt = this.recipes;
            if (this.term) {
                repfilt = repfilt.filter(r =>
                    r.name?.toLowerCase().indexOf(this.term.toLowerCase()) > -1 ||
                    r.description?.toLowerCase().indexOf(this.term.toLowerCase()) > -1 ||
                    r.food_type?.toLowerCase().indexOf(this.term.toLowerCase()) > -1
                );
            }
            return this.sort(repfilt);
        }
    },
    data() {
        return {
            term: null,
            order: null,
            selectedRecipe: null,
        }
    },
    methods: {
        sort(rs) {
            switch (this.order) {
                case 'name':
                default:
                    return rs.sort((a, b) => a.name > b.name);
                case 'newest':
                    return rs.sort((a, b) => a.created_at < b.created_at);
                case 'oldest':
                    return rs.sort((a, b) => a.created_at > b.created_at);
            }
        },
        printBG(r) {
            if (!r.img) r.img = 'no-image.jpg';
            return `/api/get-recipe-image/${r.img}`;
        },
    }
}
</script>

<style>
.star {
    z-index: 90;
    transition: all .25s cubic-bezier(0.19, 1, 0.22, 1);
}
</style>
